import { Component, OnInit, Input } from "@angular/core";

/*import { GridOptions, RowNode, CellPosition, ColDef } from '@ag-grid-enterprise/all-modules';*/
import { GridOptions, IRowNode, RowNode, CellPosition, ColDef, GridApi } from 'ag-grid-community';

import { DialogService } from "../../../services/dialog.service";

import { IconActionRendererComponent } from "../../ag-grid/icon-action-renderer.component";
import { Organization, Department } from "../../../models/organization.model";
import { genId } from "../../../../core/services/genId";
import { AuthService } from '../../../../services/auth.service';
import { LoaderService } from "../../../services/loader.service";
import { OrganizationService } from "../../../services/organization.service";
import { GridFormatterService } from "../../../services/grid-formatter.service";

@Component({
    selector: 'organization-departments',
    templateUrl: './organization-departments.component.html',
    standalone: false
})
export class OrganizationDepartmentsComponent implements OnInit {

  public columnButtonsEdit: any = {
    cellRenderer: IconActionRendererComponent,
    cellRendererParams: {
      buttons: [
        {
          action: (obj) => this.edit(),
          icon: 'edit'
        },
        {
          action: (obj) => this.delete(),
          icon: 'delete'
        }
      ]
    },
    colId: 'buttons',
    maxWidth: 70,
    filter: false,
    sortable: false,
    tooltipValueGetter: () => 'Edit/Delete Dept.'
  };

  public columnButtonsSave: any = {
    cellRenderer: IconActionRendererComponent,
    cellRendererParams: {
      buttons: [
        {
          action: (obj) => this.save(),
          icon: 'save'
        },
        {
          action: (obj) => this.cancelEdit(),
          icon: 'cancel'
        }
      ],
      enabled: this.checkEditFunction.bind(this)
    },
    colId: 'buttons',
    maxWidth: 70,
    filter: false,
    sortable: false,
  };

  public columnEditName: any = {
    editable: this.checkEditFunction.bind(this),
    field: 'displayName',
    headerName: 'Department Name',
    colId: 'name'
  };

  public columnName: any = {
    editable: false,
    field: 'displayName',
    headerName: 'Department Name',
    colId: 'name'
  };

  public departmentName: string = '';
  public displayDepartments: boolean = this.authService.User.isInternal ? true : false;
  public editedCell: CellPosition ;
  public gridColumnsEdit = [this.columnName, this.columnButtonsEdit];
  public gridColumnsSave = [this.columnEditName, this.columnButtonsSave];
	public gridOptions: GridOptions;
	private gridApi?: GridApi;
  public preEditDepartmentName: string;
  public readonly departmentNameColKey = 'name';

  @Input() organization: Organization;

  constructor(
    public authService: AuthService,
    public loader: LoaderService,
    public orgService: OrganizationService,
    public dialogService: DialogService,
    public gridFormatter: GridFormatterService
  ) {
    this.gridFormatter.applyFilterKeyboardHintTooltips(this.gridColumnsEdit);
    this.gridFormatter.applyFilterKeyboardHintTooltips(this.gridColumnsSave);
  }

  ngOnInit() {
    this.gridOptions = <GridOptions>{
      columnDefs: this.gridColumnsEdit,
        defaultColDef: { filter: true, sortable: true } as ColDef,
        enableBrowserTooltips: false,
        tooltipTrigger: 'focus',
      onGridReady: (params) => {
		  this.gridApi = params.api;
		  this.gridApi.sizeColumnsToFit();
      },
      rowData: this.organization.departments,
      suppressClickEdit: true,
      stopEditingWhenGridLosesFocus: true,
      pagination: true,
      paginationAutoPageSize: true
    };

    this.gridOptions.getRowStyle = function (params) {
      if (params.data.isEditing) {
        return { border: '2px solid #b63e2e' }
      }
    }
  }

  public addDepartment(): void {
    if (!this.departmentName.length) return;

    const dept = new Department();
    dept.displayName = this.departmentName;
    dept.id = genId();
    this.organization.departments.push(dept);

    this.loader.toggleLoader(true);
    this.orgService.save(this.organization).subscribe(data => {
		this.gridApi.setGridOption("rowData", this.organization.departments);
      this.loader.toggleLoader(false);
    });

    this.departmentName = '';
  }

  public cancelEdit(): void {
    const row = this.gridApi.getDisplayedRowAtIndex(this.editedCell.rowIndex);
    row.setDataValue(this.departmentNameColKey, this.preEditDepartmentName);
    this.setEditModeOff();
  }

  public checkEditFunction(params): boolean {
    const editing: boolean = params.node.rowIndex === this.editedCell.rowIndex;
    return editing;
  }

  public delete(): void {
    this.dialogService.openDialog("confirmCancel", "Please confirm deletion of department.");
  }

  public edit(): void {
    this.editedCell = this.gridApi.getFocusedCell();
    const rowIndex = this.editedCell.rowIndex;
    const row: IRowNode<any> = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    row.data.isEditing = true;
    this.preEditDepartmentName = row.data.displayName;
	  this.gridApi.setGridOption("columnDefs", this.gridColumnsSave);
    this.gridApi.sizeColumnsToFit();
    this.gridApi.startEditingCell({ rowIndex: rowIndex, colKey: this.departmentNameColKey });
  }

  public save(): void {
    this.saveDepartment();
    this.setEditModeOff();
  }

  public saveDepartment(): void {
    this.loader.toggleLoader(true);
    this.orgService.save(this.organization).subscribe(data => {
      this.loader.toggleLoader(false);
    })
  }

  public setEditModeOff(): void {
    this.gridApi.forEachNode((node) => { node.data.isEditing = false });
	  this.gridApi.setGridOption("columnDefs", this.gridColumnsEdit);
    this.gridApi.sizeColumnsToFit();
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    const cell = this.gridApi.getFocusedCell();
    this.organization.departments.splice(cell.rowIndex, 1);
    this.loader.toggleLoader(true);
    this.orgService.save(this.organization).subscribe(data => {
		this.gridApi.setGridOption("rowData", this.organization.departments);
      this.loader.toggleLoader(false);
    })
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
